import { render, staticRenderFns } from "./LoginButton.vue?vue&type=template&id=05aea21d&scoped=true"
import script from "./LoginButton.vue?vue&type=script&lang=ts"
export * from "./LoginButton.vue?vue&type=script&lang=ts"
import style0 from "./LoginButton.vue?vue&type=style&index=0&id=05aea21d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05aea21d",
  null
  
)

export default component.exports